var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-layout",
    { attrs: { "md-column": "md-column" } },
    [
      _vm.loadingComponent
        ? _c("md-progress", {
            staticClass: "md-accent",
            attrs: { "md-indeterminate": "" }
          })
        : _c(
            "md-theme",
            { attrs: { "md-name": "blue" } },
            [
              _c("breadcrumbs", {
                attrs: {
                  id: "scrollToError",
                  section: "Distributions",
                  nav: _vm.nav
                }
              }),
              _c(
                "md-layout",
                { staticClass: "form-wrapper", attrs: { "md-gutter": 16 } },
                [
                  _vm.$route.params.id !== undefined
                    ? _c(
                        "md-layout",
                        { attrs: { "md-flex": "100" } },
                        [
                          _c(
                            "md-whiteframe",
                            {
                              staticClass: "form-wrapper-frame",
                              attrs: { "md-elevation": "3" }
                            },
                            [
                              _c("video-preview", {
                                attrs: {
                                  distributionId: _vm.$route.params.id,
                                  playerSettings:
                                    _vm.distribution.playerSettings
                                },
                                on: {
                                  copiedToClipBoard: function($event) {
                                    return _vm.showAlertToast(
                                      "Copied to the clipboard!",
                                      "success"
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "md-layout",
                    { attrs: { "md-flex": "100" } },
                    [
                      _c(
                        "md-whiteframe",
                        {
                          staticClass: "form-wrapper-frame",
                          attrs: { "md-elevation": "3" }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "md-headline" },
                            [
                              _vm._v("Images"),
                              _vm.noImagesLive
                                ? _c("p", { staticClass: "errorMessage" }, [
                                    _vm._v(
                                      'If status is "live" the images are required'
                                    )
                                  ])
                                : _vm._e(),
                              _c("ImageUploadCroped", {
                                attrs: {
                                  accountID: _vm.accountID,
                                  "media-item": _vm.distribution,
                                  "is-distribution": true
                                },
                                on: {
                                  uploadSuccessPoster:
                                    _vm.onUploadDistributionPoster,
                                  uploadSuccessHero:
                                    _vm.onHeroImageUploadSuccess
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "md-layout",
                    { attrs: { "md-flex": "50", "md-flex-small": "100" } },
                    [
                      _c(
                        "md-whiteframe",
                        {
                          staticClass: "form-wrapper-frame",
                          attrs: { "md-elevation": "3" }
                        },
                        [
                          _c("metadata-form", {
                            attrs: {
                              title: "Distribution",
                              editMode: _vm.editMode,
                              entity: _vm.distribution,
                              "form-submitted": _vm.formSubmitted,
                              validations: _vm.$v.distribution
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "md-layout",
                    { attrs: { "md-flex": "50", "md-flex-small": "100" } },
                    [
                      _c(
                        "md-whiteframe",
                        {
                          staticClass: "form-wrapper-frame",
                          attrs: { "md-elevation": "3" }
                        },
                        [
                          _c("publishing-form", {
                            attrs: {
                              distribution: _vm.distribution,
                              "form-submitted": _vm.formSubmitted,
                              validations: _vm.$v.distribution,
                              "date-valid": _vm.dateValid
                            },
                            on: { "price-selected": _vm.handlePriceSelected }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "md-layout",
                    { attrs: { "md-flex": "100" } },
                    [
                      _c(
                        "md-whiteframe",
                        {
                          staticClass: "form-wrapper-frame",
                          attrs: { "md-elevation": "3" }
                        },
                        [
                          _c("content-form", {
                            attrs: {
                              source: _vm.distribution.source,
                              "form-submitted": _vm.formSubmitted,
                              validations: _vm.$v.distribution.source,
                              savePlaylistOrder: _vm.savePlaylistOrder
                            },
                            on: {
                              error: function($event) {
                                return _vm.showAlertToast($event, "error")
                              },
                              onSetCustomSort: _vm.setCustomSort,
                              "playlist-items": _vm.setPlaylistItems
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "md-layout",
                    { attrs: { "md-flex": "100" } },
                    [
                      _c(
                        "md-whiteframe",
                        {
                          staticClass: "form-wrapper-frame",
                          attrs: { "md-elevation": "3" }
                        },
                        [
                          _c("sections", {
                            attrs: {
                              entity: _vm.distribution,
                              "playlist-items": _vm.playlistItems
                            },
                            on: { currentsections: _vm.currentSections }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "md-layout",
                    { attrs: { "md-flex": "33", "md-flex-small": "100" } },
                    [
                      _c(
                        "md-whiteframe",
                        {
                          staticClass: "form-wrapper-frame",
                          attrs: { "md-elevation": "3", "md-align": "100" }
                        },
                        [
                          _c("qortex", {
                            key: _vm.qortexKey,
                            attrs: {
                              "qortex-data": _vm.distribution.ads.qortex,
                              "non-linear-enabled":
                                _vm.distribution.ads.nonLinearEnabled
                            },
                            on: {
                              "cancel-dialog": _vm.resetQortexDialog,
                              "qortex-updated": _vm.updateQortexData,
                              "non-linear-updated": _vm.updateNonLinearEnabled
                            }
                          }),
                          _c("div", { staticClass: "md-headline" }, [
                            _vm._v("VAST tags")
                          ]),
                          !_vm.isValidUrl && _vm.newUrl !== ""
                            ? _c("p", { staticClass: "invalidURL" }, [
                                _vm._v(_vm._s(_vm.errorMessage))
                              ])
                            : _vm._e(),
                          _vm.isValidUrl && _vm.newUrl !== ""
                            ? _c("p", { staticClass: "Urlok" }, [
                                _vm._v("URL is valid")
                              ])
                            : _vm._e(),
                          _c(
                            "md-input-container",
                            [
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.distribution.vastTagUrls.length >= 5
                                      ? "Urls cannot be more than 5"
                                      : "Add URL"
                                  )
                                )
                              ]),
                              _c("md-input", {
                                class: { "is-invalid": !_vm.isValidUrl },
                                attrs: {
                                  type: "text",
                                  disabled:
                                    _vm.distribution.vastTagUrls.length >= 5
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.validateUrl(
                                      _vm.newUrl,
                                      "isValidUrl"
                                    )
                                  }
                                },
                                nativeOn: {
                                  keydown: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.addUrl.apply(null, arguments)
                                  }
                                },
                                model: {
                                  value: _vm.newUrl,
                                  callback: function($$v) {
                                    _vm.newUrl = $$v
                                  },
                                  expression: "newUrl"
                                }
                              }),
                              _vm.distribution.vastTagUrls.length < 5
                                ? _c(
                                    "md-button",
                                    {
                                      staticClass:
                                        "md-icon-button md-raised btn",
                                      attrs: { disabled: !_vm.newUrl },
                                      on: { click: _vm.addUrl }
                                    },
                                    [
                                      _c("md-icon", {
                                        staticClass: "icon",
                                        attrs: { "md-iconset": "fa fa-plus" }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "md-list",
                            _vm._l(_vm.distribution.vastTagUrls, function(url) {
                              return _c(
                                "md-list-item",
                                { key: url, staticClass: "list" },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "text-list",
                                      attrs: {
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        href: url.startsWith("https://")
                                          ? url
                                          : "https://" + url
                                      }
                                    },
                                    [_vm._v(_vm._s(url))]
                                  ),
                                  _c(
                                    "md-button",
                                    {
                                      attrs: { id: "btn-delete" },
                                      on: {
                                        click: function($event) {
                                          _vm.distribution.vastTagUrls.splice(
                                            _vm.distribution.vastTagUrls.indexOf(
                                              url
                                            ),
                                            1
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("X")]
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          ),
                          _c("div", { staticClass: "md-headline" }, [
                            _vm._v("Display Ads")
                          ]),
                          !_vm.isValidDisplayAdServerUrl &&
                          _vm.newDisplayAdServerUrl !== ""
                            ? _c("p", { staticClass: "invalidURL" }, [
                                _vm._v("Invalid URL")
                              ])
                            : _vm._e(),
                          _vm.isValidDisplayAdServerUrl &&
                          _vm.newDisplayAdServerUrl !== ""
                            ? _c("p", { staticClass: "Urlok" }, [
                                _vm._v("URL is valid")
                              ])
                            : _vm._e(),
                          _c(
                            "md-input-container",
                            [
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.distribution.displayAdTagUrls.length >=
                                      5
                                      ? "Urls cannot be more than 5"
                                      : "Add URL"
                                  )
                                )
                              ]),
                              _c("md-input", {
                                class: {
                                  "is-invalid": !_vm.isValidDisplayAdServerUrl
                                },
                                attrs: {
                                  type: "text",
                                  disabled:
                                    _vm.distribution.displayAdTagUrls.length >=
                                    5
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.validateUrl(
                                      _vm.newDisplayAdServerUrl,
                                      "isValidDisplayAdServerUrl"
                                    )
                                  }
                                },
                                nativeOn: {
                                  keydown: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.addDisplayAdServerUrl.apply(
                                      null,
                                      arguments
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.newDisplayAdServerUrl,
                                  callback: function($$v) {
                                    _vm.newDisplayAdServerUrl = $$v
                                  },
                                  expression: "newDisplayAdServerUrl"
                                }
                              }),
                              _vm.distribution.displayAdTagUrls.length < 5
                                ? _c(
                                    "md-button",
                                    {
                                      staticClass:
                                        "md-icon-button md-raised btn",
                                      attrs: {
                                        disabled: !_vm.isValidDisplayAdServerUrl
                                      },
                                      on: { click: _vm.addDisplayAdServerUrl }
                                    },
                                    [
                                      _c("md-icon", {
                                        staticClass: "icon",
                                        attrs: { "md-iconset": "fa fa-plus" }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "md-list",
                            _vm._l(_vm.distribution.displayAdTagUrls, function(
                              url
                            ) {
                              return _c(
                                "md-list-item",
                                { key: url, staticClass: "list" },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "text-list",
                                      attrs: {
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        href: url.startsWith("https://")
                                          ? url
                                          : "https://" + url
                                      }
                                    },
                                    [_vm._v(_vm._s(url))]
                                  ),
                                  _c(
                                    "md-button",
                                    {
                                      attrs: { id: "btn-delete" },
                                      on: {
                                        click: function($event) {
                                          _vm.distribution.displayAdTagUrls.splice(
                                            _vm.distribution.displayAdTagUrls.indexOf(
                                              url
                                            ),
                                            1
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("X")]
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "md-layout",
                    { attrs: { "md-flex": "33", "md-flex-small": "100" } },
                    [
                      _c(
                        "md-whiteframe",
                        {
                          staticClass: "form-wrapper-frame",
                          attrs: { "md-elevation": "3" }
                        },
                        [
                          _c("domains-form", {
                            attrs: { entity: _vm.distribution },
                            on: {
                              created: function($event) {
                                return _vm.showAlertToast($event, "success")
                              },
                              error: function($event) {
                                return _vm.showAlertToast($event, "error")
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "md-whiteframe",
                        {
                          staticClass: "form-wrapper-frame",
                          attrs: { "md-elevation": "3" }
                        },
                        [
                          _c("sns-share-form", {
                            attrs: { "share-urls": _vm.socialMediaShareUrls },
                            on: { "clear-input": _vm.handleClearInput }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "md-layout",
                    { attrs: { "md-flex": "33", "md-flex-small": "100" } },
                    [
                      _c(
                        "md-whiteframe",
                        {
                          staticClass: "form-wrapper-frame",
                          attrs: { "md-elevation": "3" }
                        },
                        [
                          _c("player-settings-form", {
                            attrs: {
                              playerSettings: _vm.distribution.playerSettings,
                              isLive: false,
                              "form-submitted": _vm.formSubmitted,
                              validations: _vm.$v.distribution.playerSettings
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "md-layout",
                    { attrs: { "md-align": "center" } },
                    [
                      _c("stitch-loader", {
                        attrs: { loading: _vm.creatingOrUpdatingView, size: 40 }
                      }),
                      _c(
                        "md-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.creatingOrUpdatingView,
                              expression: "!creatingOrUpdatingView"
                            }
                          ],
                          staticClass: "md-raised md-primary",
                          attrs: {
                            id: "submit-btn",
                            disabled: _vm.$v.$pending
                          },
                          on: { click: _vm.onFormSubmit }
                        },
                        [_vm._v(_vm._s(_vm.editMode ? "Update" : "Create"))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bc586c02", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc586c02","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/spa/distribution/DistributionForm.vue
// module id = 821
// module chunks = 0